<div class="box">
  <div class="header">
    <div class="content" [ngClass]="'greendAnalityco' || 'primary'">RESUMEN</div>
  </div>
  <div class="content-card" *ngIf="evaluationSummary">
    <div class="employers">
      <p><strong>Empleador:</strong> {{displayEmployerName}}</p>
    </div>
    <ng-container *ngFor="let response of evaluationSummary.Responses; let i = index">
      <div class="question">
        <p><strong>Pregunta {{ i + 1 }}:</strong> {{ response.QuestionText }}</p>
        <p>
          <span [ngClass]="{ 'correct-label': response.IsCorrect, 'incorrect-label': !response.IsCorrect }">
            Respuesta {{ response.IsCorrect ? 'correcta' : 'incorrecta' }}:
          </span>
          <span class="answer-text">{{ response.SelectedAnswerText }}</span>
        </p>

      </div>
      <hr class="separator" *ngIf="i < evaluationSummary.Responses.length - 1" />
    </ng-container>

    <hr class="separator" />
    <div class="result-summary">
      <p class="total-label">Total de respuestas</p>
      <div class="result-row">
          <span class="correct-text">Respuestas correctas:</span>
          <span class="correct-value">{{ correctCount }} - {{ correctPercentage }}%</span>
      </div>
      <div class="result-row">
          <span class="incorrect-text">Respuestas incorrectas:</span>
          <span class="incorrect-value">{{ incorrectCount }} - {{ incorrectPercentage }}%</span>
      </div>
    </div>

    <div class="final-status" [ngClass]="{ 'approved': evaluationSummary.Passed, 'failed': !evaluationSummary.Passed }">
      <div class="status-wrapper">
        <div class="status-line"></div>
        <p class="status-title">
          {{ evaluationSummary.Passed ? 'CAPACITACIÓN APROBADA' : 'CAPACITACIÓN REPROBADA' }}
        </p>
        <div class="status-line"></div>
      </div>

      <p class="requirement" *ngIf="evaluationSummary && !evaluationSummary.Passed">
        Para aprobar esta capacitación se requiere contestar el {{ approvalPercentage }}% de las preguntas correctamente
      </p>
    </div>

    <div class="actions">
      <button mat-button class="btn-cancelar" (click)="close()" >CANCELAR</button>
    </div>
  </div>
</div>



